// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"527":"64a264ec","787":"d34f9676"}[chunkId] + ".chunk.js";
};